import { render } from "./teach-desc-skeleton..vue?vue&type=template&id=4154028e&scoped=true"
import script from "./teach-desc-skeleton..vue?vue&type=script&lang=js"
export * from "./teach-desc-skeleton..vue?vue&type=script&lang=js"

import "./teach-desc-skeleton..vue?vue&type=style&index=0&id=4154028e&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4154028e"]])

export default __exports__